import {
  BookingResponse,
  CreateBookingStatus,
} from "../domain_objects/BookingResponse";

export const bookingResponse: BookingResponse = {
  Booking: {
    Reference: "BC2RVWYN",
    RestaurantName: "Aurimas Inn",
    VisitDate: "2024-06-05T00:00:00",
    VisitTime: "19:30:00",
    PartySize: 2,
    ChannelCode: "ONLINE",
    SpecialRequests: "",
    PromotionId: 8,
    IpAddress: "::1",
    IsLeaveTimeConfirmed: false,
    Customer: {
      Title: "",
      FirstName: "awdawd",
      Surname: "dawawd",
      MobileCountryCode: 355,
      Mobile: "123123",
      Email: "awd@daw.awd",
      ReceiveEmailMarketing: false,
      ReceiveSmsMarketing: false,
      ReceiveResDiaryEmailMarketing: false,
      ReceiveResDiarySmsMarketing: false,
      MembershipId: "",
      CustomField: "",
      IsFavourite: false,
      Company: "",
      Phone: "",
      PhoneCountryCode: null,
      FullName: "awdawd dawawd",
      Postcode: "",
      Birthday: null,
      GroupEmailMarketingOptInText: "",
      GroupSmsMarketingOptInText: "",
      ResDiaryEmailMarketingOptInText: "",
      ResDiarySmsMarketingOptInText: "",
      ReceiveRestaurantEmailMarketing: false,
      ReceiveRestaurantSmsMarketing: false,
      RestaurantEmailMarketingOptInText: "",
      RestaurantSmsMarketingOptInText: "",
    },
    ConciergeId: null,
    ConciergeEmail: "",
    ConciergeCustomerId: null,
    Token: "0E1C077B65B08C6E2095BE67090D25D0",
    PaymentInformation: {
      IsCreditCardRequired: false,
      IsPaymentRequired: false,
      FormattedOutstandingAmount: "&#163;0.00",
      StripeOutstandingTotal: 0,
      StripePublishableKey: "",
      HasPageExpired: true,
      HoursToExpiry: "",
      MinutesToExpiry: "",
    },
    AreaId: 31,
    PaymentMethodId: "",
    PaymentIntentId: "",
    RoomNumber: "",
    PreorderGuestFormUrl: "",
    DeliveryAddress: {
      AddressLine1: "",
      AddressLine2: "",
      City: "",
      Postcode: "",
    },
    Households: null,
    IsWidgetBooking: false,
  },
  Status: CreateBookingStatus.CreditCardRequired,
  Errors: [],
  PaymentAmount: 1000,
  StripePublishableKey: "pk_test_JqYaPA1eQTABe86JsijNCvoA",
  FormattedPaymentAmount: "£10.00",
  StripeAccountId: "acct_1PIWs2CftmtVqFvT",
  SetupIntentClientSecret: "",
  PaymentIntentSecret: "",
};
